import { type IOrderListItem } from '@/types/IOrder';
import { getOrderNumberLabel } from './getOrderSequence';

export interface IOrderToastSummary {
  uuid: string;
  orderPath: string;
  title: string;
  recipientName: string | null;
  /** Город доставки — вместе с получателем отличает один новый заказ от другого. */
  city: string | null;
}

const normalizeText = (value: string | null | undefined): string | null => {
  if (typeof value !== 'string') {
    return null;
  }
  const trimmed = value.trim();
  return trimmed === '' ? null : trimmed;
};

/**
 * Готовит краткую сводку заказа для тоста, баннера ОС и центра уведомлений:
 * ссылку, номер, получателя и город. Чистая функция.
 *
 * До PAR-5189 здесь были ещё первый товар с миниатюрой, сумма с доставкой и
 * способ оплаты. Событие сокета теперь приходит в форме элемента выдачи v2 —
 * без позиций и без `selectedPayment`, — и сумма из пустого состава показала
 * бы стоимость одной доставки как стоимость заказа. Состав и сумма — в
 * карточке, куда ведёт клик.
 *
 * Чтения идут с `?.`: история уведомлений в `localStorage` хранит и события
 * прежнего формата, а заказ из сокета проверен guard'ом только по `uuid`.
 *
 * @param order - заказ из события Mercure
 * @returns данные для карточки тоста
 */
export const getOrderToastSummary = (
  order: IOrderListItem
): IOrderToastSummary => ({
  uuid: order.uuid,
  orderPath: `/order/${order.uuid}`,
  title: getOrderNumberLabel(order),
  recipientName: normalizeText(order.orderRecipient?.name),
  city: normalizeText(order.orderRecipient?.orderRecipientAddress?.city)
});
